export const PAGE_LOADED = 'PAGE_LOADED';